import React from 'react';
import { ContactForm } from '../ContactForm';
import { ContactInfoGrid } from '../shared/ContactInfoGrid';

// Secção 9 · Chamada final (fundo branco)
export const HerancasCTASection = () => (
  <section className="valuare-section" id="contacto-herancas" data-testid="herancas-cta-section">
    <div className="valuare-section-content">
      <div style={{ maxWidth: '820px', margin: '0 auto', textAlign: 'left' }}>
        <div className="valuare-section-label">Contacto</div>
        <h2 className="valuare-section-title">
          Avance com a <em>partilha</em>
        </h2>
        <p
          style={{
            fontSize: '1.0625rem',
            lineHeight: 1.85,
            color: 'var(--gray)',
            fontWeight: 300,
            maxWidth: '68ch',
            marginBottom: 0
          }}
        >
          Envie a caderneta predial e indique a finalidade da avaliação. Recebe a proposta no
          próprio dia.
        </p>
      </div>

      <ContactForm
        title="Solicitar avaliação"
        submitLabel="Solicitar avaliação"
        whatsAppMessage="Olá! Gostaria de solicitar uma avaliação para uma herança/partilha."
        idPrefix="h-"
        containerStyle={{ maxWidth: '700px', margin: '3rem auto 0' }}
      />

      <ContactInfoGrid />
    </div>
  </section>
);
